<template>
    <div  @click="dateOff" class="wxSend wxNoscroll sp4">
        <wxBack></wxBack>
        <div class="bgShow"  ref="refContent">
            <Row>
                <Form id="formSp4" ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                        用&nbsp;&nbsp;户&nbsp;&nbsp;名
                        </Col>
                        <Col span="14" offset="2">
                        <FormItem prop="username">
                            <Input type="text" disabled v-model="formInline.realname">
                            <Icon type="ios-person-outline" slot="prepend"></Icon>
                            </Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                        加餐时间
                        </Col>
                        <Col span="14" offset="2">
                        <FormItem>
                            <DatePicker :options="options3" @on-change="dateOff" readonly @click.native.stop="dateOn" :open="openDate" type="date" placeholder="请选加餐日期" v-model="formInline.addtime"></DatePicker>
                        </FormItem>
                        </Col>
                    </Row>
                    <!--{{showIt}}-->
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                        加餐餐次
                        </Col>
                        <Col span="14" offset="2">
                        <FormItem class="zdSp2" prop="shiduan">
                            <Select v-model="formInline.meal_type" size="big">
                                <Option selected v-for="(item,index) in shiduanList" :value="item.key" :key="index">{{ item.value }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                        加餐人数
                        </Col>
                        <Col span="14" offset="2">
                        <FormItem prop="addnum_count">
                            <Input @on-blur="isFocus = true;" @on-focus="isFocus = false;" number type="number" v-model="formInline.addnum"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50" style="margin-bottom: 10px;">
                        <FormItem style="width: 100%;">
                            <Button style="width: 70%;height: 50px;" type="primary" @click="edit">{{buttonV}}</Button>
                        </FormItem>
                    </Row>
                    <Row v-if="haveAddMeal" style="margin-bottom: 60px;">
                        <p  style="padding-bottom: 5px">已加餐次：</p>
                        <Table border  :columns="columns1" :data="addMealList"></Table>
                    </Row>
                </Form>
            </Row>
        </div>
        <wxNav></wxNav>
    </div>
</template>


<script>
  import { mapState, mapGetters, mapMutations } from "vuex";
  import wxBack from "../wxBack"
  import wxNav from "../wxNav"
  export default {
    props: ["wxCode"],
    data () {
      const validate_addNum = (rule,value,callback) =>{
        if(value <= 0){
          callback(new Error('加餐数不能为0！'))
        }else {callback()}
      };
      return{
        openDate:false,
        isFocus:true,
        haveAddMeal:false,
        ruleInline: {
          "addnum_count": [
            { required: true, validator:validate_addNum, trigger: 'blur' }
          ]
        },
        options3:{
          disabledDate (date) {
            var time = new Date().getTime();
            var star = new Date().getTime() - 1*1000*60*60*24;
            var end = new Date().getTime() + 7*1000*60*60*24;
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        showIt:{},
        formInline: {
          username: "",
          realname: '',
          addtime: new Date(),
          meal_type:"breakfast",
          addnum : ''
        },
        departmentList:[],
        addMealList:[],
        username:"xianrq",
        buttonV:"确定加餐",
        islock: "success",
        status:"",
        shiduanList:[
          {
            value : "早餐",
            key : "breakfast"
          },
          {
            value : "午餐",
            key : "lunch"
          },
          {
            value : "晚餐",
            key : "dinner"
          }
        ],
        columns1: [
          {
            title: '日期',
            key: 'addtime',
            width:105,
            align: 'center'
          },
          {
            title: '餐次',


            key: 'meal_type_ch',
            align: 'center'
          },
          {
            title: '加餐数',
            key: 'addnum',

            align: 'center'
          },
          {
            title: '操作',
            key: 'action',

            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delAddMeal(params.row)
                    }
                  }
                },
                '取消'
                )
              ])
            }
          }
        ]
      }
    },
    components:{
      wxNav,
      wxBack
    },
    computed: {
      ...mapState(["xcxId","xcxUser","xcxReal"]),
    },
    watch:{
      isFocus(e){
        if(!e){
          this.$Message.success("点击页面空白处展示全部信息");
        }
      },
      "formInline.addtime":function(e){
        if(e.getTime()-new Date().getTime()>7*1000*60*60*24){
          this.$Message.error("请选择一个星期之内");
          this.formInline.addtime = new Date();
        }
      }
    },
    methods:{
      ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","SET_LOADING"]),
      dateOn(){
        this.openDate = true;
      },
      dateOff(){
        this.openDate = false;
      },
      //获得人员信息
      getPeople(){
        var that = this;
        that.formInline.username = this.xcxUser;
        that.formInline.realname = this.xcxReal;
        that.getAddMealList()
      },
      //获取用户加餐数据
      getAddMealList(){
        let that=this
        let params = {};
        let today=new Date().format('yyyy-MM-dd')
        params.data = {searchValue:{username:that.xcxUser,addtime:today+'|#|2119-01-01'}};
        params.url = "/sys/mealstat/addmeallist";
        params.token = "swgykj9527";
//        alert(JSON.stringify(params.data))
        params.success = function(res) {
          if(res.data.code == "0000"){
            console.log(res);
//            alert(JSON.stringify(res.data.result.result))
            that.addMealList=[]
            that.addMealList=res.data.result.result
            if(that.addMealList.length>0){
              that.addMealList.map(item=>{
                if(item.meal_type==='breakfast'){
                  item.meal_type_ch='早餐'
                }else if(item.meal_type==='lunch'){
                  item.meal_type_ch='午餐'
                }else if(item.meal_type==='dinner'){
                  item.meal_type_ch='晚餐'
                }
              })
              that.haveAddMeal=true
            }
//            that.$Message.success(res.data.message);
//            that.formInline.addnum = "";
          }else{
            that.$Message.error(res.data.message);
          }
        };
        that.ajaxPostWX(params);
      },
      edit(){
        var that = this;
        this.$refs.formInline.validate((valid) => {
          if (valid) {
            that.formInline.addtime = new Date(that.formInline.addtime).format("yyyy-MM-dd")
            let params = {};
            params.data = that.formInline;
            params.url = "/sys/mealstat/addmealadd";
            params.token = "swgykj9527";
//                      that.showIt = params;
            params.success = function(res) {
              if(res.data.code == "0000"){
                that.$Message.success(res.data.message);
                that.formInline.addnum = "";
                that.getAddMealList()
              }else{
                that.$Message.error(res.data.message);
              }
            };
            that.ajaxPostWX(params);
          } else {
            that.$Message.error('请确保填写正确');
          }
        });

      },
      //删除加餐
      delAddMeal(data){
        let that = this
        this.$Modal.confirm({
          content: '确认取消该餐次的个人加餐？',
          onOk: function () {
            var params = {}
            params.data = {}
            params.data._id = data._id
            params.data.addtime = data.addtime
            params.data.meal_type = data.meal_type
            params.token = "swgykj9527";
            params.url = '/sys/mealstat/addmealdel'
            params.success = function (res) {
              switch (res.data.code) {
                case '0000':
                  that.$Message.success({
                    content: '删除成功'
                  })
                that.getAddMealList()
                  break
                default:
                  that.$Message.warning({
                    content: res.data.message + ' 删除失败'
                  })
              }
            }
            that.ajaxPostWX(params)
          }
        })
      }
    },
    mounted: function() {
      console.log(this.wxCode);
//      this.SET_LOADING("yes");
      this.getPeople()
      if(parseInt(this.formInline.meal_date.format("hh"))>=9 && parseInt(this.formInline.meal_date.format("hh"))<13){
        setTimeout(()=>{
          this.formInline.meal_type = "lunch"
        },100)
      }else if(parseInt(this.formInline.meal_date.format("hh"))>=13 && this.formInline.meal_date.format("hh-mm")<('18-30')){
        this.formInline.meal_date = new Date(new Date().getTime() + (1000*60*60*24));
      }else if(this.formInline.meal_date.format("hh-mm")>=('18-30')){
        this.formInline.meal_date = new Date(new Date().getTime() + (1000*60*60*24));
        setTimeout(()=>{
          this.formInline.meal_type = "lunch"
        },100)
      }

    }
  }
</script>

<style lang="scss">
    .el-select-dropdown__item{
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        text-align: center;

    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover,.el-select-dropdown__item.selected{
        color: #fff;
        background: rgba(45,140,240,.9);
    }
    .sp4{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
    .padding50{
        padding-bottom: 40vh;
    }
    .zdSp{
    .is-focus{
    .ivu-select-arrow {
        transform: rotate(180deg);
        display: inline-block;
    }
    }
    .el-input__inner{
        font-size: 12px;
        text-align: center;
    }
    }
    .zdSp2{
    .ivu-select-single .ivu-select-selection{
        height: 40px;
        font-size: 14px;
    }
    .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        height: 40px;
        line-height: 40px;
    }
    }
    .bgShow{
        padding-top: 6vw;
        font-size: 4vw;
    }
    .mrT50{
        margin-top: 3vw;
    }
    .mrT50{
        margin-top: 3vw;
    }
    .ivu-form-item{
        width: 100%;
    }
    .bgShow{
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        height: 100%;
        width: 90%;
        margin: 0 auto;
    .leftName{
        line-height: 40px;
        font-size: 4vw;
        text-align: center;
        color: #706767;
    }
    .ivu-date-picker{
        width: 100%;
    }
    }
    }
    .wxSend{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxAddMeal.vue